import React, { useState } from 'react';
import '../custom.css';
import { GrClose } from 'react-icons/gr';
import i18n from 'i18next';

const RenderActionButtons = (props) => {
    return (
        <div className="d-flex flex-row mt-auto justify-content-end">
            <div >
                <button className="finish-action-btn button button-grey mr6" onClick={props.openEmptyRewardForm}>
                {i18n.t('no')}
                 </button>
            </div>
            <div>
                <button className="finish-action-btn button button-red" onClick={props.downloadPreviousData}>
                {i18n.t('yes download')}
                 </button>
            </div>
        </div>
    );
}

const DownloadDataApprovalPopup = (props) => {
    return (
        <div className='popup'>
            <div className='popup-open d-flex flex-column'>
                <div className="d-flex flex-row justify-content-between" style={{ marginBottom: "30px" }}>
                    <div className="popup-header">
                    {i18n.t('download data')}
                    </div>
                    <div className="popup-close-icon-wrapper d-flex">
                        <GrClose role="button" onClick={props.closePopup} />
                    </div>
                </div>

                <div className="popup-content d-flex flex-column">
                {i18n.t('fill form pit data')}
                </div>

                {RenderActionButtons(props)}
            </div>
        </div>
    );
}

export default DownloadDataApprovalPopup;